import UserInfo from "../../UserInfo";

// Trakref Settings toggles — single source for the Edit form and the read-only Account Details view (#17118 AC2/AC7)
export const trakrefSettingsToggles = [
    { name: "unknownCylindersAllowed", label: "Unknown Cylinders Allowed", hint: 'Cylinder dropdowns include "Unknown Cylinder" when enabled' },
    { name: "workOrderNumberRequired", label: "Work Order Number Required", hint: "WO Number becomes required on Create Work Order form" },
    { name: "techCertificationRequired", label: "Tech Certification Required" },
    { name: "faultInformationRequired", label: "Fault Information is Required" },
    { name: "systemTaggingRequired", label: "System Tagging Required" },
    { name: "trakrefTagsUsed", label: "Trakref Tags Used" },
    { name: "customerTagsUsed", label: "Customer Tags Used" },
    { name: "v3", label: "V3 (legacy toggle — retained for parity)" },
    { name: "vitalStatsIfLeakRateLimitExceeded", label: "Require Vital Stats if Leak Rate Limit Exceeded" },
    // V3 labels and order (#15388); only owner/operator admins may change them (server ignores anyone else)
    { name: "restrictInstallEventToOwnerOperatorUsers", label: "Restrict Install Event To Owner Operator Users", ownerOperatorAdminOnly: true },
    { name: "allowZeroWeightRecoveryForShutdownAndRetrofitEvents", label: "Allow Zero Weight Recovery For Shutdown And Retrofit Events", ownerOperatorAdminOnly: true },
    // #15388 AC4: V4-only (Instance.AllowAnalytics); only System Admins may change it (server ignores anyone else)
    { name: "hasAnalytics", label: "Has Analytics", hint: "Shows Analytics in the left menu for System Owner accounts", systemAdminOnly: true },
];

// Ids use the stored casing (DB default "Lbs"); names keep the lowercase labels the form has always shown
export const weightUnitOptions = [
    { id: "Lbs", name: "lbs" },
    { id: "Kgs", name: "kgs" },
];

// Stored weight units vary in casing (Lbs/lbs/lBS), so match case-insensitively (#15388 AC3)
export const findWeightUnitOption = (value) => {
    const normalized = String(value ?? "").trim().toLowerCase();
    return weightUnitOptions.find(option => option.id.toLowerCase() === normalized);
};

export const CULTURE_DISPLAY = "English (en-US)";
export const CULTURE_NOTE = "Read-only. Multi-language support deferred.";

// V3 "Restrict Install Event To Owner Operator Users" for the account the user is working in (#15388)
export const isInstallRestricted = () => (
    (UserInfo.instances || []).find(instance => Number(instance.id) === Number(UserInfo.instanceId))?.restrictInstall === true
);

// V3 parity: a restricted account lets only System Admins and native (Super) Tenant Admins record an Install
export const canRecordInstall = () => !isInstallRestricted() || UserInfo.isNativeAdminRole();
